import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'images'
const verb = 'get'

export default class OspreyImagesGetById extends BaseAction {
    constructor(dataKey) {
        const id = 'e4398dfa-816e-477e-b18a-f35ad9286c52'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getById(imageId, params) {
        this.params = params
        this.path = `/${resource}/${imageId}`

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-get-by-id.js